exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.award[data-v-0b2fa3ae]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;align-items:flex-start\n}\n.award img[data-v-0b2fa3ae]{width:100%;height:280px\n}\n.award h4[data-v-0b2fa3ae]{margin:20px 0;font-size:1rem\n}\n.award p[data-v-0b2fa3ae]{-ms-flex:1;flex:1;margin:0 0 20px 0;font-size:.9rem;color:#545454;font-weight:400;white-space:pre-wrap;text-align:justify\n}\n.award .button[data-v-0b2fa3ae]{padding:16px 32px;font-size:1rem;color:#fff\n}\n", ""]);

// exports
